import { Document, Page, pdfjs } from 'react-pdf';
import 'react-pdf/dist/Page/AnnotationLayer.css';
import 'react-pdf/dist/Page/TextLayer.css';
import { useRef, useState } from 'react';
import ZoomControl from './zoomControl';

pdfjs.GlobalWorkerOptions.workerSrc = '/pdf.worker.min.js';

interface Props {
  binaryString: string; // raw binary string
}

const PdfViewer: React.FC<Props> = ({ binaryString }) => {
  const [numPages, setNumPages] = useState<number | null>(null);
  const [scale, setScale] = useState(1);

  const bodyRef = useRef<HTMLDivElement>(null);

  const onLoadSuccess = ({ numPages }: { numPages: number }) => {
    setNumPages(numPages);
  };

  // Convert binary string → Uint8Array
  const byteArray = new Uint8Array(binaryString.length);
  for (let i = 0; i < binaryString.length; i++) {
    byteArray[i] = binaryString.charCodeAt(i);
  }
  const base64 = btoa(binaryString);

  const withinBounds = (value: number, min: number, max: number) => {
    return Math.min(Math.max(value, min), max);
  };

  const handleZoomIn = () => {
    console.log(withinBounds(scale + 0.1, 0.1, 5));
    setScale(withinBounds(scale + 0.1, 0.1, 5));
  };

  const handleZoomOut = () => {
    setScale(withinBounds(scale - 0.1, 0.1, 5));
  };

  return (
    <>
      <ZoomControl zoom={scale} handleZoomIn={handleZoomIn} handleZoomOut={handleZoomOut}/>
      <div className="overflow-auto d-flex flex-fill mx-2 mt-2" ref={bodyRef}>
        <Document className="" file={`data:application/pdf;base64,${base64}`}  onLoadSuccess={onLoadSuccess}>
          {Array.from(new Array(numPages || 0), (_, idx) => (
            <Page
              key={`page_${idx + 1}`}
              pageNumber={idx + 1}
              height={1070}
              width={(bodyRef.current?.offsetWidth || 0) * scale}
              rotate={0}
            />
          ))}
        </Document>
      </div>
    </>
  );
};

// Simple inline style for buttons
// const buttonStyle: React.CSSProperties = {
//   margin: '0 5px',
//   padding: '6px 12px',
//   border: '1px solid #ccc',
//   borderRadius: '4px',
//   cursor: 'pointer',
//   background: '#f5f5f5',
//   fontWeight: 600
// };

export default PdfViewer;
